import SystemSummary from './SystemSummary.vue'
export default SystemSummary



// WEBPACK FOOTER //
// ./src/views/home/systemSummary/index.js